<template>
  <div>
    <ulu-order-history-order-table />
    <ulu-order-history-devices-table />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-order-history-order-table": () =>
      import(
        "@/components/orders/order/order_history_tab/OrderHistoryTabOrders"
      ),
    "ulu-order-history-devices-table": () =>
      import(
        "@/components/orders/order/order_history_tab/OrderHistoryTabDevices"
      )
  }
};
</script>
